const APP_PATH = 'app';
// const API_URL = "http://enorme-admin.harrys:8000/api";
const API_URL = "https://app.enormehotels.com/api";


const APP_VERSION = '1.0.0';

const USER_ROLE = {
    USER: 0,
    ADMIN: 1,
    RECEPTIONIST: 2,
}

const HOTEL_TYPE = {
    HOTEL: 0,
    VILLA: 1,
}

const POINTS_ACTION = {
    ADD: 1,
    REMOVE: 2,
    TRANSFER: 3,
    SIGNUP: 4,
    CHECKIN: 5,
}

const CHECKIN_STATUS = {
    NEW: 0,
    CONFIRMED: 1,
    REFUSED: 2
}

export {
    APP_PATH,
    API_URL,
    APP_VERSION,
    USER_ROLE,
    HOTEL_TYPE,
    POINTS_ACTION,
    CHECKIN_STATUS,
}